module.exports = __webpack_public_path__ + "static/media/gsheets_icon.ef0bff12.svg";